import React, { Component } from "react";
import { connect } from 'react-redux';
import { messageActions } from 'redux/actions/messageActions';
import messageFormater from 'components/helpers/messageFormater';
import flecheInfo from 'media/images/common/flecheListe.png';

const withErrorHandler = (WrappedComponent) => {
  class HocErrorHandler extends Component {

    constructor(props) {
      super(props);
      this.timer = null;
    }

    componentDidUpdate(){
      // On lance un timeout pour masquer le message au bout de 7 sec
      const { dispatch} = this.props;
      if(this.timer === null){
        this.timer = setTimeout(() => {
          dispatch(messageActions.hideMessage());
          clearTimeout(this.timer);
          this.timer = null;
          }, 7000);
      }
    }

    onMessageClick = () =>{
      const { dispatch} = this.props;
      dispatch(messageActions.hideMessage());
    }

    componentWillUnmount(){
      if(this.timer !== null){
        clearTimeout(this.timer);
        this.timer = null;
      }
    }

    render() {
      const { messageText, messageType, messageShow, showArrow} = this.props;

      return (
        <div className="generalWrapper">
        {
          messageShow && 
            <div className={`internalMessage ${messageType}`} onClick={this.onMessageClick}>
              <div className="textMessage">
                {messageFormater(messageText)}
              </div>
              {
                (messageType === "info" && showArrow === true) &&
                <div className="flecheInfo">
                  <img src={flecheInfo} alt="info" />
                </div>
              }
            </div>
        }
          <WrappedComponent {...this.props} />
        </div>
      )
    }
  }

  const mapStateToProps = (state) => {
    const { messageText, messageType, messageShow} = state.messaging;
    return {
        messageText,
        messageType,
        messageShow,
    };
  }

  return connect(mapStateToProps)(HocErrorHandler);
}

export default withErrorHandler;